module.exports = __webpack_public_path__ + "15_hair_silver.468aeb26.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/15_hair_silver.png
// module id = 9AEf
// module chunks = 0